import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import * as React from "react";
import SignInInputComponent from "./SignIn/SignInInputComponent";
import SignUpInputComponent from "@/views/Auth/Components/SignUp/SignUpInputComponent";
import { useTranslation } from "react-i18next";

interface ILabTabsProps {
	value: string;
	handleChange: Function;
}
const LabTabs: React.FC<ILabTabsProps> = ({ value, handleChange }) => {
	const { t } = useTranslation();
	return (
		<Box sx={{ width: "100%", typography: "body1" }}>
			<TabContext value={value}>
				<Box
					sx={{
						border: 1,
						borderColor: "divider",
						borderRadius: "100px",
						backgroundColor: "#ededed",
						width: "300px",
						margin: "auto",
					}}
				>
					<TabList
						onChange={(e, value) => handleChange(e, value)}
						// aria-label="lab API tabs example"
						TabIndicatorProps={{
							style: {
								height: "100%",
								color: "white",
								backgroundColor: "black",
								borderRadius: "100px",
							},
						}}
						indicatorColor="primary"
						aria-label="full width tabs example"
						centered
						variant="fullWidth"
					>
						<Tab
							label={
								<span
									style={{
										color: value === "1" ? "white" : "black",
										transition: ".5s",
									}}
								>
									{t("login.sign_up")}
								</span>
							}
							value="1"
							sx={{
								zIndex: 99,
							}}
							disableTouchRipple
						/>
						<Tab
							label={
								<span
									style={{
										color: value === "2" ? "white" : "black",
										transition: ".5s",
									}}
								>
									{t("login.sign_in")}
								</span>
							}
							value="2"
							sx={{
								zIndex: 99,
							}}
							disableTouchRipple
						/>
					</TabList>
				</Box>
				<TabPanel value="1">
					<SignUpInputComponent />
				</TabPanel>
				<TabPanel value="2">
					<SignInInputComponent />
				</TabPanel>
			</TabContext>
		</Box>
	);
};

export default LabTabs;
